import * as React from 'react';
import {
    Card,
    CardContent,
    Container,
    Grid,
    IconButton,
    InputAdornment,
    TextField,
} from '@material-ui/core';
import { PageHeading } from '../../../components/PageHeading';
import CardHeader from '@material-ui/core/CardHeader';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import copy from 'clipboard-copy';
import Typography from '@material-ui/core/Typography';
import { useStyles } from './css';
import Button from '@material-ui/core/Button';

export function AppInstallationDetailsView({ appId, installation }) {
    const classes = useStyles();
    const [showSecretKey, setShowSecretKey] = React.useState(false);

    const breadcrumbs = [
        { label: 'Apps', link: '/extranet/apps' },
        { label: 'Dashboard', link: '/extranet/apps/' + appId + '/dashboard' },
        { label: 'Installations', link: '/extranet/apps/' + appId + '/installations' },
    ];

    const copySecretKeyToClipboard = () => {
        copy(installation.oldRestApiCredentials.secretKey);
    };
    const copyAccessKeyToClipboard = () => {
        copy(installation.oldRestApiCredentials.accessKey);
    };

    return (
        <Container maxWidth="md">
            <PageHeading title={'App Installation Details'} breadcrumbs={breadcrumbs}>
                <Button
                    href={'/api/graphiql/' + installation.id}
                    variant="outlined"
                    color="primary"
                    size="small"
                >
                    Open GraphiQL
                </Button>
            </PageHeading>

            <Card elevation={3} className={classes.dashboardCard}>
                <CardHeader title="Vendor Info" />
                <CardContent>
                    <Typography gutterBottom>
                        The app was installed by the following vendor:{' '}
                        <b>{installation.vendor.name}</b>
                    </Typography>
                    <Typography gutterBottom>
                        This happened on {installation.creationDate}
                    </Typography>
                </CardContent>
            </Card>

            {installation.oldRestApiCredentials && (
                <Card elevation={3} className={classes.dashboardCard}>
                    <CardHeader title="Old Rest API Credentials" />
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    disabled
                                    label="Access key"
                                    value={installation.oldRestApiCredentials.accessKey}
                                    InputProps={{
                                        endAdornment: (
                                            <React.Fragment>
                                                <InputAdornment position="end">
                                                    <IconButton onClick={copyAccessKeyToClipboard}>
                                                        <FileCopyIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            </React.Fragment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    disabled
                                    label="Secret key"
                                    type={showSecretKey ? 'text' : 'password'}
                                    value={installation.oldRestApiCredentials.secretKey}
                                    InputProps={{
                                        endAdornment: (
                                            <React.Fragment>
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() =>
                                                            setShowSecretKey(!showSecretKey)
                                                        }
                                                    >
                                                        {showSecretKey ? (
                                                            <VisibilityIcon />
                                                        ) : (
                                                            <VisibilityOffIcon />
                                                        )}
                                                    </IconButton>
                                                </InputAdornment>
                                                <InputAdornment position="end">
                                                    <IconButton onClick={copySecretKeyToClipboard}>
                                                        <FileCopyIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            </React.Fragment>
                                        ),
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            )}
        </Container>
    );
}
